/*
 * @Author: 刘小博
 * @Date: 2023-02-17 10:37:58
 * @LastEditTime: 2023-02-17 11:01:58
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\mg\file-info-manage\modules\clientFileRouter.js
 * 客户档案
 */
import store from '@/store'
import { getlist, getAllFields } from '@/api/field'
import { regionList as getRegionList } from '@/api/common'
const clientFileRouter = [
  // 芒哥服务商列表
  {
    path: '/mg/service-list',
    name: 'MgServiceList',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/service/list.vue' //待删除
        '@/views/mg/file-info-manage/client-file/service/Page.vue'
      ),
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '服务商',
    },
  },
  //添加服务商 from 1 芒哥服务商  2服务商通用版
  {
    path: '/mg/add-service/:id/:from',
    name: 'MgaddService',
    component: () =>
      import(
        /*webpackChunkName:"client" */
        // '@/views/masterDataSystem/service/add-service.vue' // 待删除
        '@/views/mg/file-info-manage/client-file/service/Add.vue'
      ),
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '添加服务商',
    },
    async beforeEnter(to, from, next) {
      await getlist(9).then((res) => {
        if (0 === res.status) {
          let data = res.data
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of data.title_list) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientFields', res.data)
        }
      })
      await getAllFields(9).then((res) => {
        if (0 === res.status) {
          // 去除关联档案控件
          let target = res.data.filter((item) => item.type != 20)
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of target) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientAllFields', target ? target : [])
        }
      })
      store.commit('setClientDetail', {
        clientRow: {
          name: '',
          regionIdList: [],
          address: '',
          client_level_id: [''],
          doctor_position_id: '',
          doctor_title_id: '',
          doctor_level_id: '',
        },
        clientCustomOptionsList: [],
        doctorGoodsList: [],
        doctorLevelList: [],
        doctorHospitalList: [],
      })
      // 获省市区
      await getRegionList('0', '0').then((res) => {
        if (0 === res.status) {
          store.commit('setRegionList', res.data.regionList)
          next()
        }
      })
    },
  },
  // 服务商详情 from 1 芒哥服务商
  {
    path: '/mg/service-details/:server_client_id/:from',
    name: 'mgServiceDetails',
    component: () =>
      import(
        /*webpackChunkName:"client" */
        // '@/views/masterDataSystem/service/ServiceDetails.vue' // 待删除
        '@/views/mg/file-info-manage/client-file/service/Details.vue'
      ),
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '服务商详情',
    },
  },
  // 芒哥 服务商导入
  {
    path: '/mg/service-import',
    name: 'MgServiceImport',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/service/serviceImport.vue' // 待删除
        '@/views/mg/file-info-manage/client-file/service/Import.vue'
      ),
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '导入服务商',
      breadcrumb: [
        {
          title: '服务商',
          name: 'MgServiceList',
        },
      ],
    },
  },

  // 芒哥 更新服务商
  {
    path: '/mg/service-update',
    name: 'MgServiceUpdate',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/service/serviceUpdate.vue' // 待删除
        '@/views/mg/file-info-manage/client-file/service/Update.vue'
      ),
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '批量更新服务商',
      breadcrumb: [
        {
          title: '服务商',
          name: 'MgServiceList',
        },
      ],
    },
  },
]

export default clientFileRouter
